import React from 'react';
import styled from 'styled-components';
import { BaseBox, Body1, Heading1 } from '@docon/docon-ui-library';
import Image from 'shared/Image';
import { colors } from 'utilities/colorConfig';

interface IProps {
  title1?: string;
  title2?: string;
  image1: string;
  image2: string;
}

const Root = styled(BaseBox)`
  margin-top: 8%;
  text-align: center;

  ${Heading1} {
    font-weight: 700;
    margin: auto 18px;
  }

  ${Body1} {
    color: ${colors.secondaryColor};
    font-weight: 500;
    margin: 10px 24px auto;
  }
`;

function Slide({
  image1, image2,
  title1, title2,
}: IProps) {
  return (
    <Root>
      <Image src={image1} alt='Docon Universal' />
      <Image src={image2} alt='Shadow' />
      <BaseBox mt='20px'>
        <Heading1 title={title1} />
        <Body1 title={title2} />
      </BaseBox>
    </Root>
  );
}

export { Slide };
